import { createContext, useContext } from "react";

/** Where an answer renders. The drawer uses the dark card layout; the page keeps the light one. */
export type AskSurface = "page" | "drawer";

export const AskSurfaceContext = createContext<AskSurface>("page");

export const useAskSurface = () => useContext(AskSurfaceContext);
